var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFund(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#34544F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 25.5a3.3 3.3 0 1 0 0 6.7 3.3 3.3 0 0 0 0-6.7Zm1.2 4h-.6v.6c0 .3-.3.6-.6.6a.6.6 0 0 1-.7-.6v-.7H15a.6.6 0 0 1-.6-.6c0-.3.3-.6.6-.6h.6v-.6c0-.3.3-.6.7-.6.3 0 .6.3.6.6v.6h.6c.4 0 .6.3.6.6 0 .4-.2.6-.6.6ZM30 23.4h-2.2c-.9 0-1.6.8-1.6 1.7 0 .9.7 1.7 1.6 1.7H30c.2 0 .4-.2.4-.5v-2.5c0-.2-.2-.4-.4-.4ZM25.8 17.5c.2.2 0 .6-.3.6h-7a.4.4 0 0 1-.3-.8l1.5-1.4a3.2 3.2 0 0 1 4.5 0l1.5 1.6Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2 28.5c-.5 1.8-2 2.8-4 2.8h-5.4c-.3 0-.5-.3-.4-.6a4.6 4.6 0 0 0-6-6c-.3 0-.6-.1-.6-.5V23c0-2.3 1.3-3.9 3.4-4.1H27c1.7.2 2.9 1.2 3.3 2.7.1.3 0 .6-.4.6H28A3 3 0 1 0 28 28h1.8c.3 0 .5.3.4.5Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFund);
export default __webpack_public_path__ + "static/media/fund.d8ef68fbe5fc7652c1b603ab0b6aea44.svg";
export { ForwardRef as ReactComponent };